module.exports = "/assets/data/59bb06bd350952004cb6d994bf6037aa-CW10.data.json";